import angular from 'angular';
import _ from 'underscore';

export default class UserTradingOrderBuyer {
  constructor($scope, $rootScope, UserService, GeoService, UiService) {
    $scope.tabs = ['Consignee', 'Notify Party', 'Address for Receiving Docs', 'Bank Details', 'Necessary Export Docs'];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.$watch('custom_consignee_address.country_id', function() {
      if ($scope.custom_consignee_address.country_id) {
        GeoService.get_cities($scope.custom_consignee_address.country_id).then(function(data) {
          $scope.consignee_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.custom_consignee_address.city_id}))
            $scope.custom_consignee_address.city_id = null;
        });
      }
    });

    $scope.$watch('custom_notify_address.country_id', function() {
      if ($scope.custom_notify_address.country_id) {
        GeoService.get_cities($scope.custom_notify_address.country_id).then(function(data) {
          $scope.notify_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.custom_notify_address.city_id}))
            $scope.custom_notify_address.city_id = null;
        });
      }
    });

    $scope.$watch('custom_docs_address.country_id', function() {
      if ($scope.custom_docs_address.country_id) {
        GeoService.get_cities($scope.custom_docs_address.country_id).then(function(data) {
          $scope.docs_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.custom_docs_address.city_id}))
            $scope.custom_docs_address.city_id = null;
        });
      }
    });

    $scope.show_custom_consignee_address = function(status) {
      if (status) {
        $scope.use_custom_consignee_address = status;
      } else {
        $scope.deleting_custom_consignee = true;
        UserService.delete_custom_consignee(window.user_id).then(function(data) {
          if (data.success) {
            $scope.custom_consignee_address = $scope.get_custom_address();
            $scope.use_custom_consignee_address = status;
            $scope.deleting_custom_consignee = false;
            $scope.set_consignee_badge();
            $rootScope.$broadcast('set_sidebar_data', [3, 1, [{
              type: 'percentage',
              value: data.order_details_percentage
            }]]);
          }
        });
      }
    };

    $scope.show_custom_notify_address = function(status) {
      if (status) {
        $scope.use_custom_notify_address = status;
      } else {
        $scope.deleting_custom_notify = true;
        UserService.delete_custom_notify(window.user_id).then(function(data) {
          if (data.success) {
            $scope.custom_notify_address = $scope.get_custom_address();
            $scope.use_custom_notify_address = status;
            $scope.deleting_custom_notify = false;
            $scope.set_notify_badge();
            $rootScope.$broadcast('set_sidebar_data', [3, 1, [{
              type: 'percentage',
              value: data.order_details_percentage
            }]]);
          }
        });
      }
    };

    $scope.save_custom_consignee = function() {
      $scope.saving_custom_consignee = true;
      UserService.save_custom_consignee(window.user_id, $scope.custom_consignee_address).then(function(data) {
        if (data.success) {
          $scope.saving_custom_consignee = false;
          $scope.set_consignee_badge();
          $rootScope.$broadcast('set_sidebar_data', [3, 1, [{
            type: 'percentage',
            value: data.order_details_percentage
          }]]);
        }
      });
    };

    $scope.save_custom_notify = function() {
      $scope.saving_custom_notify = true;
      UserService.save_custom_notify(window.user_id, $scope.custom_notify_address).then(function(data) {
        if (data.success) {
          $scope.saving_custom_notify = false;
          $scope.set_notify_badge();
          $rootScope.$broadcast('set_sidebar_data', [3, 1, [{
            type: 'percentage',
            value: data.order_details_percentage
          }]]);
        }
      });
    };

    $scope.get_custom_address = function() {
      return {
        company_title: null,
        vat: null,
        address_line_1: null,
        address_line_2: null,
        post_code: null,
        country_id: null,
        city_id: null,
        email: null,
        phone: null,
        fax: null
      };
    };

    $scope.get_custom_consignee_address = function() {
      return window.custom_consignee_address || $scope.get_custom_address();
    };

    $scope.get_custom_notify_address = function() {
      return window.custom_notify_address || $scope.get_custom_address();
    };

    $scope.delete_custom_docs = function() {
      $scope.deleting_custom_docs = true;
      UserService.delete_custom_docs(window.user_id).then(function(data) {
        if (data.success) {
          $scope.custom_docs_address = null;
          $scope.custom_docs_address = $scope.get_custom_docs_address();
          $scope.deleting_custom_docs = false;
          $scope.set_docs_address_badge();
          $rootScope.$broadcast('set_sidebar_data', [3, 1, [{
            type: 'percentage',
            value: data.order_details_percentage
          }]]);
        }
      });
    };

    $scope.save_custom_docs = function() {
      $scope.saving_custom_docs = true;
      UserService.save_custom_docs(window.user_id, $scope.custom_docs_address).then(function(data) {
        if (data.success) {
          $scope.saving_custom_docs = false;
          $scope.set_docs_address_badge();
          $rootScope.$broadcast('set_sidebar_data', [3, 1, [{
            type: 'percentage',
            value: data.order_details_percentage
          }]]);
        }
      });
    };

    $scope.save_export_docs = function() {
      var docs = [];
      angular.forEach($scope.export_docs, function(doc) {
        if (doc.checked)
          docs.push(doc.id);
      });
      $scope.saving_export_docs = true;
      UserService.save_export_docs(window.user_id, docs).then(function(data) {
        if (data.success) {
          $scope.saving_export_docs = false;
          $scope.set_export_docs_badge();
          $rootScope.$broadcast('set_sidebar_data', [3, 1, [{
            type: 'percentage',
            value: data.order_details_percentage
          }]]);
        }
      });
    };

    $scope.get_custom_docs_address = function() {
      return {
        contact_person: null,
        company_title: null,
        address_line_1: null,
        address_line_2: null,
        post_code: null,
        country_id: null,
        city_id: null,
        email: null,
        phone: null,
        fax: null
      };
    };

    $scope.set_export_docs_badge = function() {
      var count = 0;
      angular.forEach($scope.export_docs, function(doc) {
        if (doc.checked)
          count++;
      });
      $scope.export_docs_badge = {
        count: count,
        css: UiService.get_count_css_class(count)
      };
    };

    $scope.set_bank_badge = function(percentage) {
      $scope.bank_badge = {
        percentage: percentage,
        css: UiService.get_counter_css_class(percentage)
      };
    };

    $scope.set_docs_address_badge = function() {
      var percentage = 0;
      if ($scope.custom_docs_address.contact_person)
        percentage += 10;
      if ($scope.custom_docs_address.company_title)
        percentage += 10;
      if ($scope.custom_docs_address.address_line_1)
        percentage += 10;
      if ($scope.custom_docs_address.address_line_2)
        percentage += 10;
      if ($scope.custom_docs_address.post_code)
        percentage += 10;
      if ($scope.custom_docs_address.country_id)
        percentage += 10;
      if ($scope.custom_docs_address.city_id)
        percentage += 10;
      if ($scope.custom_docs_address.email)
        percentage += 10;
      if ($scope.custom_docs_address.phone)
        percentage += 10;
      if ($scope.custom_docs_address.fax)
        percentage += 10;
      $scope.docs_address_badge = {
        percentage: percentage,
        css: UiService.get_counter_css_class(percentage)
      };
    };

    $scope.set_notify_badge = function() {
      var percentage = 0;
      if ($scope.use_custom_notify_address) {
        if ($scope.custom_notify_address.vat)
          percentage += 10;
        if ($scope.custom_notify_address.company_title)
          percentage += 10;
        if ($scope.custom_notify_address.address_line_1)
          percentage += 10;
        if ($scope.custom_notify_address.address_line_2)
          percentage += 10;
        if ($scope.custom_notify_address.post_code)
          percentage += 10;
        if ($scope.custom_notify_address.country_id)
          percentage += 10;
        if ($scope.custom_notify_address.city_id)
          percentage += 10;
        if ($scope.custom_notify_address.email)
          percentage += 10;
        if ($scope.custom_notify_address.phone)
          percentage += 10;
        if ($scope.custom_notify_address.fax)
          percentage += 10;
      } else {
        percentage = window.notify_address_percentage;
      }
      $scope.notify_badge = {
        percentage: percentage,
        css: UiService.get_counter_css_class(percentage)
      };
    };

    $scope.set_consignee_badge = function() {
      var percentage = 0;
      if ($scope.use_custom_consignee_address) {
        if ($scope.custom_consignee_address.vat)
          percentage += 10;
        if ($scope.custom_consignee_address.company_title)
          percentage += 10;
        if ($scope.custom_consignee_address.address_line_1)
          percentage += 10;
        if ($scope.custom_consignee_address.address_line_2)
          percentage += 10;
        if ($scope.custom_consignee_address.post_code)
          percentage += 10;
        if ($scope.custom_consignee_address.country_id)
          percentage += 10;
        if ($scope.custom_consignee_address.city_id)
          percentage += 10;
        if ($scope.custom_consignee_address.email)
          percentage += 10;
        if ($scope.custom_consignee_address.phone)
          percentage += 10;
        if ($scope.custom_consignee_address.fax)
          percentage += 10;
      } else {
        percentage = window.consignee_address_percentage;
      }
      $scope.consignee_badge = {
        percentage: percentage,
        css: UiService.get_counter_css_class(percentage)
      };
    };

    $scope.init = function() {
      $scope.selected_tab = 0;
      $scope.consignee_countries = angular.copy(window.countries);
      $scope.notify_countries = angular.copy(window.countries);
      $scope.docs_countries = angular.copy(window.countries);
      if (window.custom_consignee_address)
        $scope.use_custom_consignee_address = true;
      if (window.custom_notify_address)
        $scope.use_custom_notify_address = true;
      $scope.custom_consignee_address = $scope.get_custom_consignee_address();
      $scope.custom_notify_address = $scope.get_custom_notify_address();
      $scope.custom_docs_address = window.custom_docs_address || $scope.get_custom_docs_address();
      $scope.export_docs = window.export_docs;
      $scope.set_export_docs_badge();
      $scope.set_bank_badge(window.trading_bank_percentage);
      $scope.set_docs_address_badge();
      $scope.set_notify_badge();
      $scope.set_consignee_badge();
    };

    $scope.init();
  }
}

UserTradingOrderBuyer.$inject = ['$scope', '$rootScope', 'UserService', 'GeoService', 'UiService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-trading-order-buyer.ctrl.js